import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsApproachSizeM from './IconToolsApproach_size_m';

const props: CreateIconArguments = {
  l: IconToolsApproachSizeM,
  m: IconToolsApproachSizeM,
  s: IconToolsApproachSizeM,
  xs: IconToolsApproachSizeM,
  name: 'IconToolsApproach',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
